/* global __DEV__ */
/* eslint-disable global-require */

import React from 'react';
import App, { Container } from 'next/app';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import withReduxApp from 'next-redux-wrapper';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunkMiddleware from 'redux-thunk';
import { reducer, initialState } from '../store/reducer';
import { headerContext } from '../utils/context';
import actions from '../actions/types';
import { getResources } from '../actions/actionsFactory/gwRequest';
import bog from '../utils/moreBog';
import { auth } from '../utils/auth-app';

const middleware = __DEV__
  ? [require('redux-freeze'), thunkMiddleware]
  : [thunkMiddleware];

const { configs } = require('../config/build/index');

const { albHost } = configs;

export const initStore = (state = initialState) => createStore(
  reducer,
  state,
  composeWithDevTools(applyMiddleware(...middleware))
);

/* eslint-disable react/prop-types */
export default
@withReduxApp(initStore)
class MainApp extends App {
  static async getInitialProps({ Component, ctx }) {
    const { store, req } = ctx;
    // init ssr login status
    await auth(req, store.dispatch);
    // eslint-disable-next-line prefer-const
    let pageProps = Component.getInitialProps
      ? await Component.getInitialProps(ctx)
      : {};

    pageProps = pageProps || {};

    if (ctx.res) {
      try {
        pageProps.headerConfig = await getResources(`${albHost}/static/configs/binanceus/en-v7.json`, {
          headers: { Referer: 'https://www.binance.us/' },
        });
      } catch (err) {
        if (typeof window === 'undefined') {
          bog.error('en-v2.json', err);
        }
      }
    } else {
      pageProps.headerConfig = window.__NEXT_DATA__.props.initialProps.pageProps.headerConfig;
    }
    return { pageProps };
  }

  render() {
    const { Component, pageProps, store } = this.props;

    return (
      <Container>
        <headerContext.Provider value={pageProps.headerConfig}>
          <Provider store={store}>
            <Component {...pageProps} />
          </Provider>
        </headerContext.Provider>
      </Container>
    );
  }
}
